import api from "@/services/api"
import format from "@/format"
import store from "@/store"
import * as EmailValidator from "email-validator"

function isDuplicateValue(vm, prop, itemid, attribute, value) {
  return new Promise((resolve, reject) => {
    api.isDuplicateValue("page", itemid, attribute, value).then(response => {
      if (response) {
        vm.$set(prop, "error", "unique")
        resolve(true)
      } else {
        vm.$set(prop, "error", "")
        resolve(false)
      }
    })
  })
}

export default function(vm, item, sch, asPage = true) {
  return new Promise((resolve, reject) => {
    var isValid = true
    var duplicateChecks = []

    // Check required properties:
    //  Loop through schema sections
    var iref = -1
    for (let isec = 0; isec < sch.length; isec++) {
      vm.$set(sch[isec], "error", false)

      // If section not shown on page, skip section
      if (!store.getters.showOn(vm.page, sch[isec].show_on, sch[isec].hide_on)) continue

      // Section is shown on page, so increment reference index
      iref++

      // If section is a list, and validating whole page, skip section
      if (asPage && sch[isec].type == "list") continue

      if (sch[isec].properties) {
        // Loop through section properties
        for (let iprop = 0; iprop < sch[isec].properties.length; iprop++) {
          var prop = sch[isec].properties[iprop]
          var prop_name = prop.prop_name
          vm.$set(prop, "error", "")

          // If property not shown on page, skip validation
          if (!store.getters.showOn(vm.page, prop.show_on, prop.hide_on)) continue

          // Check required
          if (prop.required) {
            var failedTest = false

            if (!item[prop_name]) failedTest = true
            else if (Array.isArray(item[prop_name])) if (!item[prop_name].length) failedTest = true

            if (failedTest) {
              if (prop.format == "page_url" && prop_name == "url") continue
              vm.$set(prop, "error", "required")
              sch[isec].error = true

              // Open accordion if validating whole page
              if (asPage) vm.$refs["section" + iref][0].showContent()

              isValid = false
            }
          }

          // Check format
          if (prop.format && item[prop_name]) item[prop_name] = format[prop.format](item[prop_name])

          // Check email type
          if (prop.type == "email")
            if (!EmailValidator.validate(item[prop_name])) {
              vm.$set(prop, "error", "email")
              sch[isec].error = true

              // Open accordion if validating whole page
              if (asPage) vm.$refs["section" + iref][0].showContent()

              isValid = false
            }

          // Check price and number types
          if ((prop.type == "price" || prop.type == "number") && item[prop_name])
            if (isNaN(item[prop_name])) {
              vm.$set(prop, "error", prop.type)
              sch[isec].error = true

              // Open accordion if validating whole page
              if (asPage) vm.$refs["section" + iref][0].showContent()

              isValid = false
            }

          // Check unique
          if (prop.unique && item[prop_name]) {
            var urlsecref = iref
            duplicateChecks.push(
              isDuplicateValue(vm, prop, item.ItemID, prop_name, item[prop_name]).then(isDup => {
                sch[isec].error = isDup
                if (isDup) {
                  // Open accordion if validating whole page
                  if (asPage) vm.$refs["section" + urlsecref][0].showContent()

                  isValid = false
                }
              })
            )
          }
        }
      }
    }

    Promise.all(duplicateChecks).then(() => {
      resolve(isValid)
    })
  })
}
